import { Component, OnInit } from '@angular/core';
import { AuthService, ErrorStateService, MemberQuery, MemberDetails, LoggingService } from '@fgb/core';
import { Router } from '@angular/router';
import { MLBAM_AUTH_CODE_KEY } from 'src/app/modules/user/components/mlbam-account-selection/mlbam-account-selection.component';

@Component({
  selector: 'fgb-login-accounts-page',
  templateUrl: './login-accounts-page.component.html',
  styleUrls: ['./login-accounts-page.component.scss'],
})
export class LoginAccountsPageComponent implements OnInit {
  availableAccounts: MemberDetails[];
  /** The MLBAM auth code, present only when this page was reached via the code-exchange flow. */
  mlbamCode: string | null = null;
  /** Set while a selected account is being logged in, to disable further selection. */
  submitting = false;

  constructor(
    private memberQuery: MemberQuery,
    private authService: AuthService,
    private errorService: ErrorStateService,
    private logService: LoggingService,
    private router: Router
  ) {}

  ngOnInit() {
    this.availableAccounts = this.memberQuery.getAvailableAccounts() || [];
    this.mlbamCode = sessionStorage.getItem(MLBAM_AUTH_CODE_KEY);
    if (this.availableAccounts.length === 0) {
      this.logService.warning('No accounts available to choose from - redirecting back to the login page...');
      this.router.navigate(['/login']);
    }
  }

  /**
   * Complete the login for the selected account via the MLBAM code-exchange endpoint.
   * Only used when the page was reached with an auth code (mlbamCode set); the credential-based
   * flow continues to use the per-account links in the template.
   */
  selectAccount(account: MemberDetails) {
    if (!this.mlbamCode || this.submitting) {
      return;
    }
    console.log(account);
    this.submitting = true;
    this.errorService.clearErrors();

    this.authService
      .mlbamLoginWithAccount(this.mlbamCode, account.ExternalRefNumber)
      .toPromise()
      .then(() => {
        sessionStorage.removeItem(MLBAM_AUTH_CODE_KEY);
      })
      .catch((error) => {
        this.submitting = false;
        if (error && error.error && error.error.code === 'AccountNotActive') {
          this.errorService.addError('This account is not active and cannot be used to log in.');
        } else {
          this.errorService.addError('You are not authorised to login into this account.');
        }
      });
  }
}
